"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const AkColors = __importStar(require("@atlaskit/util-shared-styles"));
exports.colors = [
    AkColors.akColorPrimary1,
    AkColors.akColorSecondary1,
    AkColors.akColorP75,
    AkColors.akColorR75,
    AkColors.akColorG75,
    AkColors.akColorY75,
    AkColors.akColorT75,
    AkColors.akColorSecondary2,
    AkColors.akColorP100,
    AkColors.akColorR100,
    AkColors.akColorG100,
    AkColors.akColorY100,
    AkColors.akColorT100,
    AkColors.akColorSecondary3,
    AkColors.akColorP200,
    AkColors.akColorR200,
    AkColors.akColorG200,
    AkColors.akColorY200,
    AkColors.akColorT200,
    AkColors.akColorSecondary4,
    AkColors.akColorP300,
    AkColors.akColorR300,
    AkColors.akColorG300,
    AkColors.akColorY300,
    AkColors.akColorT300,
    AkColors.akColorSecondary5,
    AkColors.akColorP400,
    AkColors.akColorR400,
    AkColors.akColorG400,
    AkColors.akColorY400,
    AkColors.akColorT400,
    AkColors.akColorP500,
    AkColors.akColorR500,
    AkColors.akColorG500,
    AkColors.akColorY500,
    AkColors.akColorT500
];
